(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const upsellForms = document.querySelectorAll('.js-upsell-form');

  upsellForms.forEach(function(form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const button = form.querySelector('button');
      const formData = new FormData(form);

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Toevoegen...';

      try {
        // toevoegen
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!addRes.ok) throw new Error('Fout bij toevoegen');

        const addData = await addRes.json();

        // sections ophalen
        let sectionIds = [];
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        cartItemsComponents.forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });

        if (!sectionIds.length) {
          const cartDrawer = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawer.dataset.sectionId) {
            sectionIds.push(cartDrawer.dataset.sectionId);
          } else {
            sectionIds = ['cart-icon-bubble', 'cart-drawer'];
          }
        }

        let sectionsJson = {};
        try {
          const sectionsRes = await fetch(`/?sections=${sectionIds.join(',')}`);
          sectionsJson = await sectionsRes.json();
        } catch (err) {
          console.warn('Kon sections niet ophalen', err);
        }

        // zelfde events als thema
        document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            data: {
              source: 'product-form-component',
              itemCount: addData.quantity || 1,
              productId: addData.product_id,
              sections: sectionsJson
            }
          }
        }));

        // drawer openen
        const cartDrawer = document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.showDialog === 'function') {
            cartDrawer.showDialog();
          } else if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

      } catch (error) {
        console.error(error);
      } finally {
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
